import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Planbook } from "@shared/models/planbook"
import type ModalManager from "cc-frontend/services/modal-manager"

@tagName("")
export default class PlanbookMenuConfirmMigrateToUnifiedLessonsBodyComponent extends Component {
  // args
  planbook!: Planbook
  closeMenu!: () => void

  // services
  @service modalManager!: ModalManager

  @action
  migrateToUnifiedLessons() {
    this.modalManager.openModal("planner/modals/migrating-to-unified-lessons", {
      planbook: this.planbook,
    })
    this.closeMenu()
  }
}
